import { checkAllowedRegion, checkAllowedEveryRegion } from "shared/imports/permissionFunctions"

/**
 * isRegionCustom
 *
 * Determines whether or not a region is a "custom" region.
 * This relies on an extraordinary hack in the way that we
 * surface custom regions to the frontend.
 *
 * @param  {String} regionValue  - A region value
 * @return {Boolean}             - Whether or not that value is a custom region
 */
export const isRegionCustom = (regionValue) => typeof regionValue === "string" && regionValue.includes("custom")

/**
 * isRegionDisabled
 *
 * Returns whether a region should be disabled or not
 * for a given user.
 *
 * @param  {Object} region - An item from the SupportedRegion enum
 * @return {Boolean}       - Whether or not that region is disabled
 */
export const isRegionDisabled = (region) => {
    if (region.is_international_region && !region.international_region_ready) {
        // regions that are international, but not ready, are disabled
        return true
    }

    if (isRegionCustom(region.value)) {
        return false
    } else if (region.child_regions) {
        switch (region.value) {
            case DjangIO.app.models.SupportedRegion.states_and_local.value:
                // Enabled when user has at least 1 state and 1 local
                return !(
                    checkAllowedRegion(DjangIO.app.models.SupportedRegion.states.child_regions) &&
                    checkAllowedRegion(DjangIO.app.models.SupportedRegion.local.child_regions)
                )
            case DjangIO.app.models.SupportedRegion.user_global.value:
                // always enabled since this refers to all of a user's allowed regions
                // (aka what is "global" to them)
                return false
            case DjangIO.app.models.SupportedRegion.all_regions.value:
            case DjangIO.app.models.SupportedRegion.states.value:
            case DjangIO.app.models.SupportedRegion.local.value:
            case DjangIO.app.models.SupportedRegion.international.value:
                return !checkAllowedRegion(region.child_regions)
            default:
                return !checkAllowedEveryRegion(region.child_regions)
        }
    } else {
        return !Userdata.allowed_regions_values.includes(region.value)
    }
}

export const isRegionEnabled = (region) => {
    return !isRegionDisabled(region)
}
